module.exports = __webpack_public_path__ + "media/images/cornell_channels_landing-4500f48ba68c95f6f41c6558f85083cb.jpg";